<template>
  <div id="app">
    <!-- 登录页面会通过路由显示 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 20px;
  min-height: 100vh;
  background: #f0f2f5;
}

/* 为了避免时间筛选器遮挡内容，给主内容添加上边距 */
.total-chart-container {
  margin-top: 80px;
}

.areas-container {
  margin-top: 20px;
}
</style>
